/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserCrmSettings} from '../models/UserCrmSettings';
import type {UserCrmSettingsSaveRequest} from '../models/UserCrmSettingsSaveRequest';

export interface GetUserCrmSettings$Request {
    userId: number;
}

export interface GetUserCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserCrmSettingsRequest = createAction<PayloadData<void, GetUserCrmSettings$Request>>('USER_CRM_SETTINGS_CONTROLLER__GET_USER_CRM_SETTINGS__REQUEST');
export const getUserCrmSettingsSuccess = createAction<PayloadData<UserCrmSettings, GetUserCrmSettings$Request>>('USER_CRM_SETTINGS_CONTROLLER__GET_USER_CRM_SETTINGS__SUCCESS');
export const getUserCrmSettingsFailure = createAction<PayloadData<Error, GetUserCrmSettings$Request, true>>('USER_CRM_SETTINGS_CONTROLLER__GET_USER_CRM_SETTINGS__FAILURE');

export const getUserCrmSettingsActions = [
    getUserCrmSettingsRequest,
    getUserCrmSettingsSuccess,
    getUserCrmSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserCrmSettings = (meta: GetUserCrmSettings$Request, config?: GetUserCrmSettings$Config) => {
    return {
        CALL_API: {
            types: getUserCrmSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/crm-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserCrmSettings$Request {
    userId: number;
    userCrmSettingsSaveRequest: UserCrmSettingsSaveRequest;
}

export interface SaveUserCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserCrmSettingsRequest = createAction<PayloadData<void, SaveUserCrmSettings$Request>>('USER_CRM_SETTINGS_CONTROLLER__SAVE_USER_CRM_SETTINGS__REQUEST');
export const saveUserCrmSettingsSuccess = createAction<PayloadData<void, SaveUserCrmSettings$Request>>('USER_CRM_SETTINGS_CONTROLLER__SAVE_USER_CRM_SETTINGS__SUCCESS');
export const saveUserCrmSettingsFailure = createAction<PayloadData<Error, SaveUserCrmSettings$Request, true>>('USER_CRM_SETTINGS_CONTROLLER__SAVE_USER_CRM_SETTINGS__FAILURE');

export const saveUserCrmSettingsActions = [
    saveUserCrmSettingsRequest,
    saveUserCrmSettingsSuccess,
    saveUserCrmSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserCrmSettingsSaveRequest} meta.userCrmSettingsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserCrmSettings = (meta: SaveUserCrmSettings$Request, config?: SaveUserCrmSettings$Config) => {
    return {
        CALL_API: {
            types: saveUserCrmSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/crm-settings`,
            TRANSPORT_REQUEST_BODY: meta.userCrmSettingsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

